import { Modal, Skeleton, Spin } from "antd";
import dayjs from "dayjs";
import { useAntdMessage } from "hooks/useAntdMessage";
import { isEmpty } from "lodash-es";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "utils/helper";

const ModalDetailScheduleDay = ({
  data,
  setDataDetail,
  dataTemp,
  handleClickSlot,
}) => {
  return (
    <Modal
      title={null}
      footer={null}
      open={data}
      onCancel={() => setDataDetail(null)}
    >
      <ContentScheduleDay
        date={data?.date}
        onClickSlot={handleClickSlot}
        schedule_admin_id={dataTemp?.schedule_admin_id}
        data={data}
      />
    </Modal>
  );
};

export default ModalDetailScheduleDay;

const ContentScheduleDay = ({
  date = null,
  onClickSlot,
  data = {},
  schedule_admin_id,
}) => {
  const isLoading = false;
  const isFetching = false;
  const { t } = useTranslation();
  const { message } = useAntdMessage();

  const generateHour = useMemo(() => {
    if (isEmpty(data)) return [];
    const temp = [];
    Array(24)
      .fill(0)
      .forEach((_, i) => {
        temp.push({
          start_time: dayjs(dayjs().startOf("day").hour(i)).format("HH:mm:ss"),
          end_time: dayjs(dayjs().startOf("day").hour(i))
            .add(i === 23 ? 59 : 60, "minute")
            .format("HH:mm:ss"),
          percentage: 100,
        });
      });
    return temp;
  }, [data]);

  const showDetailScheduleTime = useCallback(
    (data) => {
      if (data?.status === "available" || data?.currentSchedule) {
        // nanti harusnya jadwal nya sendiri warna nya beda sendiri, dan bisa di klik, atau pake mekanisme laama *diavailable jadwalnya
        //   // Check if the time has already passed for today's date
        const isToday = dayjs(date).isSame(dayjs(), "day");
        const isPastTime =
          isToday &&
          dayjs(
            `${dayjs(date).format("YYYY-MM-DD")} ${data.end_time}`
          ).isBefore(dayjs());

        //   // Only allow clicking on the slot if it's not a past time
        if (!isPastTime) {
          const start_time = data.currentSchedule
            ? data.meeting_schedules_data.start_time
            : data.start_time;
          const end_time = data.currentSchedule
            ? data.meeting_schedules_data.end_time
            : data.end_time;

          onClickSlot({
            ...data,
            date: dayjs(date).format("YYYY-MM-DD"),
            start_time,
            end_time,
          });
        } else {
          message.error(t("meeting_schedule.cannot_select_past_time_slots"));
        }
      }
    },
    [date, onClickSlot, t, message]
  );

  const dataStatus = useCallback(
    (item) => {
      // const status =
      //   item.isAvailable === false && item.meeting_schedules_data
      //     ? "booked"
      //     : !schedule_admin_id && item.children
      //     ? "available"
      //     : item.isAvailable
      //     ? "available"
      //     : "unavailable";

      const status =
        !schedule_admin_id && item.children ? "available" : item.status;

      const text = (
        <div className="flex flex-col justify-center ">
          <div>
            {dayjs(item.start_time, "HH:mm:ss").format("HH:mm")} s/d{" "}
            {dayjs(item.end_time, "HH:mm:ss").format("HH:mm")}
          </div>
          <div className="font-bold line-clamp-1 overflow-hidden">
            {status === "booked" &&
              `Booked by ${item.meeting_schedules_data?.contact?.name}`}
            {status === "available" && `Available`}
            {status === "unavailable" && `Not Available`}
          </div>
        </div>
      );

      return { status, text };
    },
    [schedule_admin_id]
  );

  const joinAvailableSlots = useCallback((data) => {
    if (!data.children || data.children.length === 0) {
      return data;
    }

    const joinedChildren = [];
    let currentGroup = null;

    for (let i = 0; i < data.children.length; i++) {
      const child = data.children[i];

      if (child.status === "available") {
        if (currentGroup === null) {
          currentGroup = {
            start_time: child.start_time,
            end_time: child.end_time,
            percentage: child.percentage,
            // currentSchedule: child.currentSchedule,
            status: child.status,
          };
        } else {
          currentGroup.end_time = child.end_time;
          currentGroup.percentage += child.percentage;

          // if (child.currentSchedule) {
          //     currentGroup.currentSchedule = child.currentSchedule;
          // }
        }
      } else {
        // Jika status unavailable, tutup grup saat ini (jika ada) dan tambahkan child yang unavailable
        if (currentGroup !== null) {
          joinedChildren.push(currentGroup);
          currentGroup = null;
        }

        // Tambahkan child yang unavailable
        joinedChildren.push(child);
      }
    }

    // Jangan lupa tambahkan grup terakhir jika masih ada
    if (currentGroup !== null) {
      joinedChildren.push(currentGroup);
    }

    return {
      ...data,
      children: joinedChildren,
    };
  }, []);

  const renderListSlot = useMemo(() => {
    const combineData = [];
    generateHour.forEach((hourItem) => {
      const availableItem = data.available_times.find((available) => {
        return (
          dayjs(available.start_time, "HH:mm:ss").isSame(
            dayjs(hourItem.start_time, "HH:mm:ss"),
            "minute"
          ) &&
          dayjs(available.end_time, "HH:mm:ss").isSame(
            dayjs(hourItem.end_time, "HH:mm:ss"),
            "minute"
          )
        );
      });
      if (availableItem) {
        combineData.push({
          ...hourItem,
          ...availableItem,
        });
      } else {
        combineData.push({
          ...hourItem,
          isAvailable: false,
        });
      }
    });
    return combineData.map((item, index) => {
      // ga ada jam aneh, atau jamnya bulat perjam
      if (!item.children) {
        const { status, text } = dataStatus(item);
        return (
          <div
            key={index}
            className={cn(
              "p-1 text-xs text-white font-bold min-h-12 hover:cursor-pointer hover:opacity-80 overflow-hidden flex",
              item.currentSchedule
                ? "bg-purple-500"
                : status === "available"
                ? "bg-green-500"
                : status === "booked"
                ? "bg-red-500"
                : "bg-gray-500"
            )}
            style={{
              width: `${item.percentage}%`,
            }}
            onClick={() => showDetailScheduleTime({ ...item, status })}
          >
            {text}
          </div>
        );
      } else {
        let itemChildren = { ...item };
        if (!schedule_admin_id) {
          // ketika yg dipilih adalah grup auto assign
          itemChildren = joinAvailableSlots(item);
        }
        // kalau jam nya aneh atau ada yg tidak bulat
        return (
          <div
            key={index}
            className="text-xs relative w-full min-h-12"
            style={{
              width: `${item.percentage}%`,
            }}
          >
            <div className="flex w-full ">
              {itemChildren.children.map((child, childIndex) => {
                const { status, text } = dataStatus(child);
                return (
                  <div
                    key={childIndex}
                    className={cn(
                      "min-h-12 text-white font-bold p-1 hover:cursor-pointer hover:opacity-80 overflow-hidden flex",
                      child.currentSchedule
                        ? "bg-purple-500"
                        : status === "available"
                        ? "bg-green-500"
                        : status === "booked"
                        ? "bg-red-500"
                        : "bg-gray-500"
                    )}
                    style={{
                      width: `${child.percentage}%`,
                    }}
                    onClick={() => showDetailScheduleTime({ ...child, status })}
                  >
                    {text}
                  </div>
                );
              })}
            </div>
          </div>
        );
      }
    });
  }, [
    data,
    generateHour,
    dataStatus,
    showDetailScheduleTime,
    schedule_admin_id,
    joinAvailableSlots,
  ]);
  return (
    <>
      <div className="py-4">
        <p className="leading-3 ">{dayjs(date).format("YYYY")}</p>
        <p className="text-2xl font-bold">
          {dayjs(date).format("dddd, MMM D")}
        </p>
      </div>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          <Spin spinning={isFetching}>
            <div className="flex flex-col gap-y-1 max-h-96 overflow-y-auto border-y py-2 ">
              {renderListSlot}
            </div>
          </Spin>
        </>
      )}
    </>
  );
};
